import moment from "moment";

import { BilledServiceItem } from "@/Billing/Api/Inbox/Dto/Response/BillingInboxItem";
import { Client } from "@/Common/Api/Client";
import { ClientResponse } from "@/Common/Api/ClientResponse";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Popup } from "@/Common/Components/Modals/Popup";
import { PortalStatusButton } from "@/Common/Components/Portal/PortalStatusIcon";
import { displayToast, MessageToast } from "@/Common/Components/Toast/Toast";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { PrintHelper } from "@/Common/Helpers/PrintHelper";
import { EnumMyleLoginPermission } from "@/Common/Models/EnumMyleLoginPermission";
import { PortalSyncStatus } from "@/Common/Models/Portal/Enums/PortalSyncStatus";
import { PrivateBill_BilledTo } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ExportMode } from "@/ExportableFile/Models/enum/ExportMode";
import { IExportableDto } from "@/ExportableFile/Models/ExportableFile";
import { FileTypeInvoice } from "@/ExportableFile/Models/FileTypes/FileTypeInvoice";
import { IFaxPrintExportableFileConfig } from "@/ExportableFile/Models/IFaxPrintExportableFileConfig";
import { MarkBillAsPaidResponse } from "@/Patient/Api/Dto/Responses/MarkBillAsPaidResponse";
import { PatientPrivateBillListItem } from "@/Patient/Models/History/PatientPrivateBillListItem";
import { IPatientPrivateBillModel } from "@/Patient/Models/UI/History/IPatientPrivateBillModel";
import { MarkBillAsPaidPopup } from "./MarkBillAsPaidPopup";
import { IPatientHistoryPrivateBillsProps } from "./PrivateBillControl";

import styles from "./PrivateBillView.module.scss";

class PrivateBillView extends React.Component<IPatientHistoryPrivateBillsProps, never> {
    private readonly isPortalEnabled: boolean = cacheStore.ClinicSettings_Portal.EnablePortalWebsite;
    private readonly isPortalInvitationFlowV2Enabled: boolean = cacheStore.ClinicSettings.EnablePortalInvitationFlowV2;

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        const privateBillModel = this.props.Model;
        const billId = privateBillModel.get("PrivateBillId");
        const privateBill = privateBillModel.get("PrivateBillList").toArray().filter(x => x.Model.PrivateBillId == billId).firstOrDefault();
        let classname = "scrollable m-billing-view";

        const selectedSite = cacheStore.GetSiteById(privateBillModel.get("SelectedBillSiteId"));
        const hasCostPermission = sessionStore.hasPermission(EnumMyleLoginPermission.BillingCostPermission);

        if (this.props.DoNotRenderAsScrollable)
            classname = "m-billing-view";

        return (
            <div className="summary-container no-border">
                {this.renderHeaderBanner(privateBillModel)}

                {privateBillModel.get("IsInvalidPopupOpen") && (
                    <Popup title={cacheStore.GetString("InvalidateBillLabel")} cssClass="double-booking" closeTarget={this.props.CloseInvalidOp}>
                        <div className="p-body">
                            <div>
                                {![PortalSyncStatus.Unsent, PortalSyncStatus.Revoked].some(x => x == privateBill.Model.getGlobalPortalStatus()) && (
                                    <span className="red-text">
                                        <strong>
                                            {cacheStore.GetString("WarningPrivateBillInvalidationPortal")}
                                        </strong>
                                    </span>
                                )}
                            </div>
                            <textarea
                                className="form-control"
                                onChange={this.OnNotesChange.bind(this)}
                                id="history_create_invalidation"
                                disabled={false}
                                rows={4}
                                style={{ maxHeight: "300px", marginTop: "5px" }}
                                data-cy="privateBillView-invalidateBillNote"
                            />
                        </div>
                        <div className="p-footer flex-display flex-end">
                            <ButtonGroup>
                                <ButtonControl
                                    onClick={() => sessionStore.dispatch(this.props.CloseInvalidOp)}
                                    label={cacheStore.GetString("CancelLabel")}
                                    className="btn btn-default"
                                />
                                <ButtonControl
                                    onClick={() => sessionStore.dispatch(this.props.SaveInvalidationOp)}
                                    label={cacheStore.GetString("SaveLabel")}
                                    className="btn btn-primary"
                                    dataCy="privateBillView-save"
                                />
                            </ButtonGroup>
                        </div>
                    </Popup>
                )}

                {privateBillModel.get("IsMarkAsPaidPopupOpen") &&
                    (
                        <MarkBillAsPaidPopup
                            onClose={() => this.closeMarkBillAsPaidPopup()}
                            onSubmit={(paymentMethod, paymentDate) => this.onSubmitFromMarkBillAsPaidPopup(paymentMethod, paymentDate)}
                        />
                    )
                }

                <div data-hvar="60" className={classname} data-cy="privateBillView-billInfo">

                    {this.renderBillInfos(privateBillModel)}
                    <hr />
                    {!!selectedSite ? (
                        <>
                            <div style={{ width: "100%" }}>
                                {privateBillModel.get("BilledService").map((service: BilledServiceItem, idx: number) => (
                                    <div key={"bs_" + idx} className="flex-container" style={{ width: "100%" }}>
                                        <div className="bill-service-component flex-container" style={{ width: "74%", justifyContent: "center" }}>
                                            <div className="multiplier-column fcol" style={{ paddingTop: "10px", minWidth: "0px" }}>
                                                <strong>{service.ServiceMultiplicator}</strong>
                                            </div>
                                            <div className="label-column fcol" style={{ paddingTop: "10px", paddingRight: "25px" }}>
                                                <strong> x</strong>
                                            </div>
                                            <div className="autocomplete-column fcol" style={{ paddingTop: "10px", whiteSpace: "pre-wrap" }}>
                                                <strong>{service.ServiceName}</strong>
                                            </div>
                                        </div>
                                        <div className="flex-container" style={{ justifyContent: "flex-end", width: "323px", paddingTop: "10px" }}>
                                            {this.servicePriceValidation(service, hasCostPermission)}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {(hasCostPermission || sessionStore.getCurrentEmployee().isActiveSiteMexico() === false) && (
                                <div className="billing-charges">
                                    <div style={{ justifyContent: "flex-end", width: "390px", paddingTop: "30px" }}>
                                        <div className="flex-container charges" style={{ justifyContent: "center" }}>
                                            <div className="label">
                                                <span>
                                                    {cacheStore.GetString("TotalAmountLabel")}
                                                </span>
                                            </div>
                                            <div className="fl-x-2" style={{ marginRight: "5px" }}>
                                                <strong>
                                                    {"$ "} {Number(privateBillModel.get("TotalAmount")).toFixed(2)}
                                                </strong>
                                            </div>
                                        </div>
                                        <div className="flex-container charges" style={{ justifyContent: "center" }}>
                                            <div className="label">
                                                <span>
                                                    {cacheStore.GetString("DiscountLabel")}
                                                </span>
                                            </div>
                                            <div className="fl-x-2" style={{ marginRight: "5px" }}>
                                                <strong>
                                                    {`${privateBillModel.get("DiscountType")} `} {Number(privateBillModel.get("Discount")).toFixed(2)}
                                                </strong>
                                            </div>
                                        </div>
                                        <div className="flex-container charges" style={{ justifyContent: "center" }}>
                                            <div className="label">
                                                <span>
                                                    {cacheStore.GetString("SubtotalLabel")}
                                                </span>
                                            </div>
                                            <div className="fl-x-2" style={{ marginRight: "5px" }}>
                                                <strong>
                                                    {"$ "} {Number(privateBillModel.get("Subtotal")).toFixed(2)}
                                                </strong>
                                            </div>
                                        </div>

                                        {(selectedSite?.isGst() || !!privateBillModel.get("GSTTotal")) && (
                                            <div className="flex-container charges" style={{ justifyContent: "center" }}>
                                                <div className="label">
                                                    <span>
                                                        {cacheStore.GetString("GstMLabel") + " (" + Number(privateBillModel.get("GST")).toFixed(2) + "%)"}
                                                    </span>
                                                </div>
                                                <div className="fl-x-2" style={{ marginRight: "5px" }}>
                                                    <strong>
                                                        {"$ "} {Number(privateBillModel.get("GSTTotal")).toFixed(2)}
                                                    </strong>
                                                </div>
                                            </div>
                                        )}

                                        {(selectedSite?.isPstOrQst() || !!privateBillModel.get("QSTTotal")) && (
                                            <div className="flex-container charges" style={{ justifyContent: "center" }}>
                                                <div className="label">
                                                    <span>
                                                        {selectedSite.getPstOrQstLabel() + " (" + Number(privateBillModel.get("QST")).toFixed(2) + "%)"}
                                                    </span>
                                                </div>
                                                <div className="fl-x-2" style={{ marginRight: "5px" }}>
                                                    <strong>
                                                        {"$ "} {Number(privateBillModel.get("QSTTotal")).toFixed(2)}
                                                    </strong>
                                                </div>
                                            </div>
                                        )}

                                        {(selectedSite?.isHst() || !!privateBillModel.get("HSTTotal")) && (
                                            <div className="flex-container charges" style={{ justifyContent: "center" }}>
                                                <div className="label">
                                                    <span>
                                                        {cacheStore.GetString("HstMLabel") + " (" + Number(privateBillModel.get("HST")).toFixed(2) + "%)"}
                                                    </span>
                                                </div>
                                                <div className="fl-x-2" style={{ marginRight: "5px" }}>
                                                    <strong>
                                                        {"$ "} {Number(privateBillModel.get("HSTTotal")).toFixed(2)}
                                                    </strong>
                                                </div>
                                            </div>
                                        )}

                                        {(!selectedSite?.isCanadaSite() || !!privateBillModel.get("GenericTaxTotal")) && (
                                            <div className="flex-container charges" style={{ justifyContent: "center" }}>
                                                <div className="label">
                                                    <span>
                                                        {cacheStore.GetString("TaxLabel") + " (" + Number(privateBillModel.get("GenericTax") ? privateBillModel.get("GenericTax") : "0").toFixed(2) + "%)"}
                                                    </span>
                                                </div>
                                                <div className="fl-x-2" style={{ marginRight: "5px" }}>
                                                    <strong>
                                                        {"$ "} {Number(privateBillModel.get("GenericTaxTotal") ? privateBillModel.get("GenericTaxTotal") : "0").toFixed(2)}
                                                    </strong>
                                                </div>
                                            </div>
                                        )}
                                        <hr />
                                        <div className="flex-container charges" style={{ justifyContent: "center" }}>
                                            <div className="label">
                                                <span>
                                                    {cacheStore.GetString("GrandTotalLabel").toUpperCase()}
                                                </span>
                                            </div>
                                            <div className="fl-x-2" style={{ marginRight: "5px" }}>
                                                <strong>
                                                    {"$ "} {Number(privateBillModel.get("Total")).toFixed(2)} {cacheStore.defaultCurrencyUnit}
                                                </strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div style={{ marginTop: "20px" }}>
                                <div className="flex-container billing-view mb">
                                    <div className="label" style={{ height: "30px" }} />
                                    <div className="grow">
                                        <div className="flex-container notes">
                                            <div className="label"><span className="form-lable uppercase">{cacheStore.GetString("NotesLabel")}</span></div>
                                            <div className="note-value grow bottom-border-b"><strong>{JSXHelper.BreakStringIntoParagraphs(privateBillModel.get("Notes"))}</strong></div>
                                        </div>
                                    </div>
                                </div>

                                {privateBillModel.get("IsInvalid") === true && (
                                    <div className="flex-container billing-view">
                                        <div className="label" />
                                        <div className="grow">
                                            <div className="flex-container notes">
                                                <div className="label"><span className="form-lable uppercase red-text">{cacheStore.GetString("InvalidationNoteLabel")}</span></div>
                                                <div className="note-value grow"><strong>{privateBillModel.get("InvalidNote")}</strong></div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    ) : <p className="text-bold">{cacheStore.GetString("ErrorLabel")}</p>
                    }
                </div>

                {!this.props.IsPopup && (
                    this.renderFooter(privateBillModel, privateBill)
                )}
            </div>
        );
    }

    public renderHeaderBanner(privateBillModel: IPatientPrivateBillModel): JSX.Element {
        const canFax = privateBillModel.get("BilledTo") === PrivateBill_BilledTo.ThirdParty
            && cacheStore.ClinicSettings.EnablePrivateBillRecipient;

        const canPrint = (
            !privateBillModel.get("IsFromNote")
            && (
                privateBillModel.get("IsClosed")
                || (
                    cacheStore.ClinicSettings.EnablePrivateBillRecipient
                    && (
                        privateBillModel.get("BilledTo") === PrivateBill_BilledTo.Patient
                        || (privateBillModel.get("BilledTo") === PrivateBill_BilledTo.ThirdParty && !!privateBillModel.get("RecipientDetails")?.RecipientName)
                    )
                )
            )
        );

        const canDuplicate = privateBillModel.get("IsClosed")
            && !privateBillModel.get("IsFromNote");

        const canInvalidate =
            (!privateBillModel.get("IsFromNote") &&
                (
                    privateBillModel.get("IsClosed")
                    || (cacheStore.ClinicSettings.EnablePrivateBillRecipient && privateBillModel.get("IsLockedForEditing"))
                )
            )
            && privateBillModel.get("CanInvalidateBill")
            && !privateBillModel.get("IsInvalid");

        return (
            <div className="banner" style={{ height: "68px" }}>
                <div className="clearfix" style={{ display: "grid", gridTemplateAreas: '"title actions""footer footer' }} data-cy="privateBillView-title">
                    <label style={{ gridArea: "title" }}>
                        {`${cacheStore.GetString("CreatedByLabel")} ${privateBillModel.get("CreatedBy")} ${privateBillModel.get("BillDateForHeader")}`}
                    </label>

                    <div style={{ gridArea: "actions", display: "grid", gridAutoFlow: "column", margin: "0 11px 0 auto", gap: "5px" }}>
                        {canFax && (
                            <a onClick={() => this.FaxPrivateBillClick()}>{cacheStore.GetString("FaxLabel")}</a>
                        )}

                        {canFax && canPrint && (<> | </>)}

                        {canPrint && (
                            <a onClick={() => this.printPrivateBillingClick()}>{cacheStore.GetString("PrintLabel")}</a>
                        )}

                        {(canFax || canPrint) && canDuplicate && (<> | </>)}

                        {canDuplicate && (
                            <a onClick={() => this.onDuplicateBill()}>{cacheStore.GetString("DuplicateLabel")}</a>
                        )}

                        {(canFax || canPrint || canDuplicate) && canInvalidate && (<> | </>)}

                        {canInvalidate && (
                            <a onClick={() => this.isInvalidOnClick()}>{cacheStore.GetString("InvalidateBillLabel")}</a>
                        )}
                    </div>

                    {privateBillModel.get("IsInvalid") && (
                        <h3 style={{ gridArea: "footer" }} className="thin-font no-margin red-text bold ellipsis-auto">
                            {cacheStore.GetString("InvalidatedByLabel")} {privateBillModel.get("InvalidatedBy")} {privateBillModel.get("InvalidDate")}
                        </h3>
                    )}
                </div>
            </div>
        );
    }

    public renderBillInfos(privateBillModel: IPatientPrivateBillModel): JSX.Element {
        const showPrivateBillRecipientFields = cacheStore.ClinicSettings.EnablePrivateBillRecipient
            && privateBillModel.get("BilledTo") == PrivateBill_BilledTo.ThirdParty;

        return (
            <div className={styles.billInfosContainer}>
                <div className={styles.billDetails}>
                    <label>{cacheStore.GetString("InvoiceNumberLabel")}</label>
                    <span>{privateBillModel.get("BillNumber")}</span>

                    <label>{cacheStore.GetString("DateOfVisitLabel")}</label>
                    {privateBillModel.get("DateOfVisit") != null &&
                        <span>{moment(privateBillModel.get("DateOfVisit")).format("YYYY/MM/DD")}</span>
                    }

                    {cacheStore.SiteCache.length > 1 && (
                        <>
                            <label>{cacheStore.GetString("SiteDLabel")}</label>
                            <span>{privateBillModel.get("SiteName")}</span>
                        </>
                    )}

                    {privateBillModel.get("Provider") && (
                        <>
                            <label>{cacheStore.GetString("ProviderLabel")}</label>
                            <span>{privateBillModel.get("Provider")}</span>
                        </>
                    )}

                    <label>{cacheStore.GetString("PaymentMethodLabel")}</label>
                    <span>{privateBillModel.get("PaymentMethod")}</span>

                    {cacheStore.ClinicSettings.EnablePrivateBillRecipient && privateBillModel.get("BilledTo") == PrivateBill_BilledTo.ThirdParty && (
                        <>
                            <label>{cacheStore.GetString("BilledToLabel")}</label>
                            <span>{cacheStore.GetString("ThirdPartyLabel")}</span>
                        </>
                    )}
                </div>
                {showPrivateBillRecipientFields && (
                    <div className={styles.billDetails}>
                        <h4 className="thin-font">{cacheStore.GetString("BillRecipient")}</h4>

                        <label>{cacheStore.GetString("RecipientLabel")}</label>
                        <span>{privateBillModel.get("RecipientDetails")?.RecipientName}</span>

                        <label>{cacheStore.GetString("AddressLabel")}</label>
                        <span>{privateBillModel.get("RecipientDetails")?.RecipientAddress}</span>

                        <label>{cacheStore.GetString("PhoneNumberLabel")}</label>
                        <span>{privateBillModel.get("RecipientDetails")?.RecipientPhoneNumber}</span>

                        <label>{cacheStore.GetString("FaxNumberLabel")}</label>
                        <span>{privateBillModel.get("RecipientDetails")?.RecipientFaxNumber}</span>
                    </div>
                )}
            </div>
        );
    }

    public renderFooter(privateBillModel: IPatientPrivateBillModel, privateBill: PatientPrivateBillListItem): JSX.Element {
        let portalSyncButton: JSX.Element = null;
        if (this.props.PatientModel && privateBill && this.isPortalEnabled &&
            (this.props.PatientModel.IsRegisteredToPortal() || this.isPortalInvitationFlowV2Enabled)) {
            const buttonProps = PortalHelper.getPortalButtonPropsForShareableItem(
                privateBill.Model
            );

            portalSyncButton = (
                <PortalStatusButton
                    className="push-left-5"
                    icon="share"
                    onClick={() => sessionStore.dispatch(LocalPatientOperations.History.PrivateBill_PortalStatusClicked, { bill: privateBill.Model })}
                    {...buttonProps}
                    disabled={this.props.DisableButtons}
                />
            );
        }

        const isPaymentMethodPayable = privateBillModel.get("PaymentMethod") === cacheStore.GetString("PayableLabel");
        const isCloseButtonDisabled = isPaymentMethodPayable && cacheStore.ClinicSettings.EnablePrivateBillRecipient;
        const closeButton = (
            <button
                style={{ verticalAlign: "bottom" }}
                className="btn btn-primary push-right-5"
                onClick={this.closeSelectedBill.bind(this)}
                disabled={isCloseButtonDisabled || this.props.DisableButtons}
            >
                {cacheStore.GetString("CloseLabel")}
            </button>
        );

        return (
            <div className="meta-footer" data-cy="privateBillView-footer">
                <div className="flex-container pull-right">
                    <div>
                        {isPaymentMethodPayable && privateBillModel.get("CanModifyPaymentInformation") && !privateBillModel.get("IsInvalid") && (
                            <button
                                style={{ verticalAlign: "bottom" }}
                                className="btn btn-primary push-right-5"
                                onClick={() => this.openMarkBillAsPaidPopup()}
                                disabled={this.props.DisableButtons}
                            >
                                {cacheStore.GetString("CloseLabel")}
                            </button>
                        )}
                        {!privateBillModel.get("IsClosed") && !privateBillModel.get("IsLockedForEditing") && !privateBillModel.get("IsInvalid") && (
                            <>
                                <button
                                    style={{ verticalAlign: "bottom" }}
                                    className="btn btn-danger push-right-5"
                                    onClick={() => this.deleteSelectedBill()}
                                    disabled={this.props.DisableButtons}
                                >
                                    {cacheStore.GetString("DeleteLabel")}
                                </button>
                                <button
                                    style={{ verticalAlign: "bottom" }}
                                    className="btn btn-primary push-right-5"
                                    onClick={() => this.onModifyClick()}
                                    disabled={this.props.DisableButtons}
                                >
                                    {cacheStore.GetString("ModifyLabel")}
                                </button>
                                {closeButton}
                            </>
                        )}
                        {portalSyncButton}
                    </div>

                </div>
            </div>
        );
    }

    public isInvalidOnClick(): void {
        LocalEvent.Dispatch(this.props.InvalidateOp);
    }

    public OnNotesChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {
        var operation = new LocalEvent(this.props.InvalidationChangeOp);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    private deleteSelectedBill(): void {
        sessionStore.showPopup({
            title: cacheStore.GetString("DeleteSelectedBillLabel"),
            content: cacheStore.GetString("DeleteSelectedBillMessageLabel"),
            showCancel: true,

            okLabel: cacheStore.GetString("DeleteLabel"),
            okAction: () => LocalEvent.Dispatch(LocalPatientOperations.History.PrivateBill_DeleteSelectedBill)
        });
    }

    private closeSelectedBill(): void {
        sessionStore.showPopup({
            title: cacheStore.GetString("CloseSelectedBillLabel"),
            content: cacheStore.GetString("CloseSelectedBillMessageLabel"),
            showCancel: true,

            okLabel: cacheStore.GetString("CloseLabel"),
            okAction: () => LocalEvent.Dispatch(LocalPatientOperations.History.PrivateBill_CloseSelectedBill),

            altButtonLabel: cacheStore.GetString("CloseAndPrintLabel"),
            altButtonAction: () => LocalEvent.Dispatch(LocalPatientOperations.History.PrivateBill_CloseSelectedBillThenPrint)
        });
    }

    private onModifyClick(): void {
        var op = new LocalEvent(LocalPatientOperations.History.PrivateBill_OnModifyOrDuplicateClick);
        op.AddItem("isNewBill", false);
        LocalEventDispatcher.dispatch(op);
    }

    private onDuplicateBill(): void {
        var op = new LocalEvent(LocalPatientOperations.History.PrivateBill_OnModifyOrDuplicateClick);
        op.AddItem("isNewBill", true);
        LocalEventDispatcher.dispatch(op);
    }

    private servicePriceValidation(service: BilledServiceItem, hasCostPermission: boolean): JSX.Element {
        let returnElement: JSX.Element;
        returnElement = (
            <>
                {(hasCostPermission || !sessionStore.getCurrentEmployee().isActiveSiteMexico()) && (
                    <div className="flex-container" style={{ width: "93%" }}>
                        <strong>$ {service.ServicePrice ? String(service.ServicePrice.toFixed(2)) : 0}</strong>
                    </div>
                )}
                <div className="fl-x-2" style={{ width: "100%" }}>
                    <strong>$ {service.ServicePrice ? String((service.ServicePrice * service.ServiceMultiplicator).toFixed(2)) : 0}</strong>
                </div>
            </>
        );
        return <>{returnElement}</>;
    }

    private openMarkBillAsPaidPopup(): void {
        sessionStore.dispatch(LocalPatientOperations.History.PrivateBill_OpenMarkBillAsPaidPopup);
    }

    private closeMarkBillAsPaidPopup(): void {
        sessionStore.dispatch(LocalPatientOperations.History.PrivateBill_CloseMarkBillAsPaidPopup);
    }

    private async onSubmitFromMarkBillAsPaidPopup(paymentMethod: string, paymentDate: Date): Promise<void> {
        const response = await Client.postAsync<MarkBillAsPaidResponse>(
            ServerOperations.Server.Myle_Patient_History_MarkPrivateBillAsPaid,
            {
                privateBillId: this.props.Model.get("PrivateBillId"),
                paymentMethod,
                paymentDate
            }
        );

        if (!response?.isSuccess ?? false) {
            sessionStore.showPopup(response.errors);
            return;
        }

        sessionStore.dispatch(
            LocalPatientOperations.History.PrivateBill_UpdateBillAndCloseMarkBillAsPaidPopup,
            {
                privateBillId: response.data.PrivateBill.Id,
                paymentType: response.data.PrivateBill.PayementType,
                paymentDate: response.data.PrivateBill.PaymentDate,
                canModifyPaymentInformation: response.data.PrivateBill.CanModifyPaymentInformation,
                lastUpdateDate: response.data.PrivateBill.LastUpdateDate
            }
        );
    }

    private async FaxPrivateBillClick(): Promise<void> {
        const recipientDetails = this.props.Model.get("RecipientDetails");
        const patientContactId = this.props.PatientModel?.IndividualResponse?.Contact_id;
        let response: ClientResponse<any>;

        if (!recipientDetails?.RecipientFaxNumber || !recipientDetails?.RecipientName) {
            response = await Client.postAsync<any>(
                ServerOperations.Server.Myle_Patient_History_GeneratePatientPrivateBillPDF,
                {
                    PrivateBillId: this.props.Model.get("PrivateBillId")
                }
            );

            if (response?.isSuccess) {
                const fileName = response.data.FileName + ".pdf";
                const fileTypePrivateBill = this.initFileTypePrivateBillFile(fileName);
                sessionStore.dispatchMain(LocalOperations.MainComponentViewOperations.FaxPrintExportableFile, {
                    config: {
                        exportableFile: fileTypePrivateBill,
                        exportMode: ExportMode.Fax,
                        patientContactId: patientContactId,
                        popupTitle: cacheStore.GetString("FaxBillLabel"),
                        hideSignaturePinControl: true,
                        onFaxAsync: async (file: IExportableDto, signedFile: IExportableDto, faxNumber: string, faxDescription: string): Promise<ClientResponse> => {
                            const privateBillId = this.props.Model.get("PrivateBillId");
                            const response = await Client.postAsync<any>(ServerOperations.Server.Myle_PrivateBill_SaveRecipientDetailsAndFaxPrivateBill, {
                                PrivateBillId: privateBillId,
                                RecipientName: faxDescription,
                                RecipientFaxNumber: faxNumber
                            });

                            if (response?.isSuccess) {
                                displayToast(MessageToast.Success, cacheStore.GetString("FaxSentLabel"));
                                sessionStore.dispatch(LocalPatientOperations.History.PrivateBill_LoadPatientPrivateBill);
                            }

                            return response;
                        }
                    } as IFaxPrintExportableFileConfig
                });
            }
        }
        else {
            response = await Client.postAsync<any>(ServerOperations.Server.Myle_PrivateBill_SaveRecipientDetailsAndFaxPrivateBill, {
                PrivateBillId: this.props.Model.get("PrivateBillId"),
                RecipientName: recipientDetails?.RecipientName,
                RecipientFaxNumber: recipientDetails?.RecipientFaxNumber
            });

            if (response?.isSuccess) {
                displayToast(MessageToast.Success, cacheStore.GetString("FaxSentLabel"));
                sessionStore.dispatch(LocalPatientOperations.History.PrivateBill_LoadPatientPrivateBill);
            }
        }

        if (!response?.isSuccess) {
            sessionStore.showPopup(response.errors);
            return;
        }
    }

    private async printPrivateBillingClick(): Promise<void> {
        let response;

        if (cacheStore.ClinicSettings.EnablePrivateBillRecipient && !this.props.Model.get("IsLockedForEditing")) {
            response = await Client.postAsync<any>(
                ServerOperations.Server.Myle_PrivateBill_Publish,
                { PrivateBillId: this.props.Model.get("PrivateBillId") }
            );

            sessionStore.dispatch((LocalPatientOperations.History.PrivateBill_LoadPatientPrivateBill));
        }
        else {
            response = await Client.postAsync<any>(
                ServerOperations.Server.Myle_Patient_History_GeneratePatientPrivateBillPDF,
                { PrivateBillId: this.props.Model.get("PrivateBillId") }
            );
        }

        PrintHelper.ShowPrintPreviewFileName(`${response.data?.FileName}.pdf`);

        if (!response?.isSuccess) {
            sessionStore.showPopup(response.errors);
            return;
        }
    }

    private initFileTypePrivateBillFile(fileName: string): FileTypeInvoice {
        return new FileTypeInvoice({
            ObjectId: fileName,
            privateBillId: this.props.Model.get("PrivateBillId"),
            description: cacheStore.GetString("PrivateBillLabel"),
            date: this.props.Model.get("BillDate")
        });
    }
}

export { PrivateBillView };
